<div class="content-with-filled-button">
  <h1 class="title">{{ copyService.copies.metodo_desembolso_title }}</h1>
  <p class="sub-title">{{ copyService.copies.metodo_desembolso_sub_title }}</p>
  <div class="checkbox">
    <voxel-radio-button-group id="radioLiveAbroad">
      <voxel-radio-button
        *ngFor="let checkbox of checkboxList"
        [id]="checkbox.id"
        [checked]="checkbox.checked"
        (radioButtonChange)="radioButtonChange($event)"
        [value]="checkbox.value"
      >
        {{ checkbox.label }}
      </voxel-radio-button>
    </voxel-radio-button-group>
  </div>
</div>
<vcl-alert
  *ngIf="flag1 == true"
  class="alert"
  [type]="'warning'"
  [light]="true"
  [icon]="error"
>
  {{ copyService.copies.metodo_desembolso_alert1 }}
</vcl-alert>

<vcl-alert
  *ngIf="flag3 == true"
  class="alert"
  [type]="'warning'"
  [light]="true"
  [icon]="error"
>
  {{ copyService.copies.metodo_desembolso_alert3 }}
</vcl-alert>

<vcl-alert
  *ngIf="flag4 == true"
  class="alert"
  [type]="'warning'"
  [light]="true"
  [icon]="error"
>
  {{ copyService.copies.metodo_desembolso_alert4 }}
</vcl-alert>

<vcl-alert
  *ngIf="flag5 == true"
  class="alert"
  [type]="'warning'"
  [light]="true"
  [icon]="error"
>
  {{ copyService.copies.metodo_desembolso_alert5 }}
</vcl-alert>

<p *ngIf="flag4 == true" class="como-quieres-repart">
  {{ copyService.copies.two_metodo_desembolso }}
</p>
<p *ngIf="flag4 == true" class="recuerda-que-el-valo">
  {{ copyService.copies.total_amount_require }} {{ value }}.
</p>
<div *ngIf="flag4 == true" class="select-activated">
  <form id="formMonto" class="form row" [formGroup]="formGroup">
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field class="label" label="Cheque" msgErr="Mensaje de error">
        <input
          vclInput
          placeholder="$0"
          class="value"
          id="inputValueMonto"
          type="number"
          formControlName="monto"
        />
      </vcl-form-field>
    </div>
  </form>
</div>
<p *ngIf="flag4 == true" class="el-valor-a-transferi">
  {{ copyService.copies.metodo_alert_message }}
</p>

<p *ngIf="flag5 == true" class="como-quieres-repart">
  {{ copyService.copies.two_metodo_desembolso }}
</p>
<p *ngIf="flag5 == true" class="recuerda-que-el-valo">
  {{ copyService.copies.total_amount_require }} {{ value }}.
</p>
<div *ngIf="flag5 == true" class="select-activated">
  <form id="formMonto" class="form row" [formGroup]="formGroup">
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field class="label" label="Cheque" msgErr="Mensaje de error">
        <input
          vclInput
          placeholder="$0"
          class="value"
          id="inputValueMonto"
          type="number"
          formControlName="monto"
        />
      </vcl-form-field>
    </div>
  </form>
</div>
<p *ngIf="flag5 == true" class="el-valor-a-transferi">
  {{ copyService.copies.metodo_alert_message }}
</p>
<app-controls
  id="docIntroBtns"
  [hasPrevious]="true"
  [nextLabel]="copyService.copies.metodo_desembolso_next_button"
  (next)="next()"
  (only_previous)="previous()"
  [nextDisabled]="!flag6"
></app-controls>
